// plantillasAutoescuela.js — ESPEJO del cuerpo de aws_lambdas/_shared_autoescuela/plantillasAutoescuela.js: el texto
// EXACTO de cada plantilla de WhatsApp de autoescuela (castellano = SYSTEM_TEMPLATES de c_sendTemplate; catalán = lo
// creado en Meta) y vistaPlantilla(), que lo rellena con los datos y aplica la plantilla A MEDIDA de la empresa.
// NO editar entre las marcas: `node aws_lambdas/_shared_autoescuela/plantillasCopias.js`.
// Ficha: docs/features/autoescuela-plantillas-por-empresa.md
import { elegirAMedida, definicionAMedida } from "./plantillasAMedida";

// ── plantillasAutoescuela: cuerpo compartido (inicio) ──
// ── catálogo generado (inicio): NO editar a mano, `node aws_lambdas/_shared_autoescuela/plantillasCopias.js` ──
const PLANTILLAS_AUTOESCUELA = {
  "alumno_aprobado_resena_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te escribe:\n\n🎉 Enhorabuena, {{2}}, ya tienes tu permiso {{3}}.\n\nHa sido un placer acompañarte hasta aquí. Si estás contento con nosotros, nos ayudas mucho dejando una reseña en Google, es solo un minuto.",
      "cta": "Dejar reseña"
    }
  },
  "bienvenida_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nAlta registrada ✅\n\nHola {{2}}, tu matrícula para el permiso {{3}} está registrada.\n\nNorma de las prácticas: {{4}}\n\nPor este chat recibirás tus prácticas y sus recordatorios."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nAlta registrada ✅\n\nHola {{2}}, la teva matrícula per al permís {{3}} està registrada.\n\nNorma de les pràctiques: {{4}}\n\nPer aquest xat rebràs les teves pràctiques i els seus recordatoris."
    }
  },
  "bienvenida_disponibilidad_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nAlta registrada ✅\n\nHola {{2}}, tu matrícula para el permiso {{3}} está registrada.\n\nNorma de las prácticas: {{4}}\n\nPulsa el botón para indicarnos qué días y franjas puedes dar clase. Por este chat recibirás tus prácticas y sus recordatorios.",
      "flow": "Indicar disponibilidad"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nAlta registrada ✅\n\nHola {{2}}, la teva matrícula per al permís {{3}} està registrada.\n\nNorma de les pràctiques: {{4}}\n\nPrem el botó per indicar-nos quins dies i franges pots fer classe. Per aquest xat rebràs les teves pràctiques i els seus recordatoris.",
      "flow": "Indicar disponibilitat"
    }
  },
  "bienvenida_disponibilidad_alumno_v2_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nAlta registrada ✅\n\nHola {{2}}, tu matrícula para el permiso {{3}} está registrada.\n\nNorma de las prácticas: {{4}}\n\nPulsa el botón para indicarnos qué días y franjas puedes dar clase. Por este chat recibirás tus prácticas y sus recordatorios.",
      "flow": "Indicar disponibilidad"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nAlta registrada ✅\n\nHola {{2}}, la teva matrícula per al permís {{3}} està registrada.\n\nNorma de les pràctiques: {{4}}\n\nPrem el botó per indicar-nos quins dies i franges pots fer classe. Per aquest xat rebràs les teves pràctiques i els seus recordatoris.",
      "flow": "Indicar disponibilitat"
    }
  },
  "bienvenida_teorica_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nAlta registrada ✅\n\nHola {{2}}, tu matrícula para el permiso {{3}} está registrada.\n\nNorma de las prácticas: {{4}}\n\nCurso de teoría en {{5}}: {{6}}\n\nPor este chat recibirás tus prácticas y sus recordatorios."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nAlta registrada ✅\n\nHola {{2}}, la teva matrícula per al permís {{3}} està registrada.\n\nNorma de les pràctiques: {{4}}\n\nCurs de teoria a {{5}}: {{6}}\n\nPer aquest xat rebràs les teves pràctiques i els seus recordatoris."
    }
  },
  "bono_practicas_agotandose_trial_v2": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTe quedan {{3}} clases prácticas de tu bono {{4}}.\n\nTe lo recordamos para que puedas organizar tus próximas clases con tiempo."
    }
  },
  "cap_caducidad_alumno_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu CAP caduca el {{3}}.\n\nSi quieres renovarlo a tiempo, responde a este mensaje y te ayudamos."
    }
  },
  "certificado_dgt_caduca_crm_trial": {
    "es": {
      "body": "Certificado de la DGT por caducar ⏳\n\n*{{1}}*: el certificado digital de {{2}} con el que la autoescuela se conecta a la DGT caduca {{3}}.\n\nRenuévalo y súbelo en «Conexión con la DGT» para que la conexión siga funcionando.",
      "cta": "Abrir Conexión con la DGT"
    },
    "ca": {
      "body": "Certificat de la DGT a punt de caducar ⏳\n\n*{{1}}*: el certificat digital de {{2}} amb què l'autoescola es connecta a la DGT caduca {{3}}.\n\nRenova'l i puja'l a «Connexió amb la DGT» perquè la connexió continuï funcionant.",
      "cta": "Obrir Connexió amb la DGT"
    }
  },
  "cumpleanos_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}*\n\nTe desea feliz cumpleaños, {{2}} 🎂🎁🎈🎉"
    }
  },
  "curso_certificado_trial": {
    "es": {
      "documento": true,
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, aquí tienes tu certificado del curso {{3}}, finalizado el {{4}}.\n\nGuárdalo por si te lo piden."
    }
  },
  "curso_inscripcion_confirmada_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nInscripción confirmada ✅\n\nHola {{2}}, tu plaza en el curso {{3}} está confirmada. Empieza el {{4}} a las {{5}} en {{6}}.\n\nPara cualquier cambio, escríbenos por este chat."
    }
  },
  "curso_plaza_libre_trial": {
    "es": {
      "header": "PLAZA DISPONIBLE",
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTenemos una plaza reservada para ti en el curso {{3}}, que empieza el {{4}} a las {{5}}.\n\nConfírmanos si la quieres y queda a tu nombre.",
      "botones": [
        "Lo quiero",
        "Ahora no"
      ]
    }
  },
  "curso_recordatorio_trial": {
    "es": {
      "header": "RECORDATORIO DE CURSO",
      "body": "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nTienes plaza en el curso {{3}}, que empieza el {{4}} a las {{5}} en {{6}}.\n\n¿Nos confirmas tu asistencia?",
      "botones": [
        "Confirmar asistencia",
        "Cancelar plaza"
      ]
    }
  },
  "disponibilidad_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, estamos organizando tus prácticas de las próximas semanas.\n\nDisponibilidad que tenemos registrada: {{3}}.\n\nPulsa el botón para indicar o actualizar qué días y franjas puedes dar clase. Si no ha cambiado, no hace falta que hagas nada.",
      "botones": [
        "Indicar disponibilidad"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, estem organitzant les teves pràctiques de les properes setmanes.\n\nDisponibilitat que tenim registrada: {{3}}.\n\nPrem el botó per indicar o actualitzar quins dies i franges pots fer classe. Si no ha canviat, no cal que facis res.",
      "botones": [
        "Indicar disponibilitat"
      ]
    }
  },
  "disponibilidad_alumno_flow_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, estamos organizando tus prácticas de las próximas semanas.\n\nDisponibilidad que tenemos registrada: {{3}}.\n\nPulsa el botón para indicar o actualizar qué días y franjas puedes dar clase. Si no ha cambiado, no hace falta que hagas nada.",
      "flow": "Indicar disponibilidad"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, estem organitzant les teves pràctiques de les properes setmanes.\n\nDisponibilitat que tenim registrada: {{3}}.\n\nPrem el botó per indicar o actualitzar quins dies i franges pots fer classe. Si no ha canviat, no cal que facis res.",
      "flow": "Indicar disponibilitat"
    }
  },
  "disponibilidad_alumno_flow_v2_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, estamos organizando tus prácticas de las próximas semanas.\n\nDisponibilidad que tenemos registrada: {{3}}.\n\nPulsa el botón para indicar o actualizar qué días y franjas puedes dar clase. Si no ha cambiado, no hace falta que hagas nada.",
      "flow": "Indicar disponibilidad"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, estem organitzant les teves pràctiques de les properes setmanes.\n\nDisponibilitat que tenim registrada: {{3}}.\n\nPrem el botó per indicar o actualitzar quins dies i franges pots fer classe. Si no ha canviat, no cal que facis res.",
      "flow": "Indicar disponibilitat"
    }
  },
  "enlace_pago_crm_trial_v2": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, aquí tienes tu enlace para pagar {{3}}. Pulsa el botón para completar el pago de forma segura.",
      "footer": "Gracias por tu confianza",
      "cta": "Pagar ahora"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, aquí tens l'enllaç per pagar {{3}}. Prem el botó per completar el pagament de manera segura.",
      "footer": "Gràcies per la teva confiança",
      "cta": "Pagar ara"
    }
  },
  "examen_aviso_oficina_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nExamen apuntado ✅\n\nAlumno: {{2}}\nExamen: {{3}}\nFecha del examen: {{4}}\n\nPago del examen pendiente: pídeselo antes del {{5}}.\n\nPulsa el botón para abrir su ficha en la app.",
      "cta": "Abrir ficha"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nExamen apuntat ✅\n\nAlumne: {{2}}\nExamen: {{3}}\nData de l'examen: {{4}}\n\nPagament de l'examen pendent: demana-li abans del {{5}}.\n\nPrem el botó per obrir la seva fitxa a l'app.",
      "cta": "Obrir fitxa"
    }
  },
  "examen_propuesta_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, te hemos propuesto para el examen {{3}} del {{4}}.\n\nConfirma con los botones si podrás asistir. Si no puedes, la autoescuela buscará otra fecha contigo.",
      "botones": [
        "Sí, voy",
        "No puedo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, t'hem proposat per a l'examen {{3}} del {{4}}.\n\nConfirma amb els botons si hi podràs assistir. Si no pots, l'autoescola buscarà una altra data amb tu.",
      "botones": [
        "Sí, hi aniré",
        "No puc"
      ]
    }
  },
  "examen_recordatorio_crm_trial_v2": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, te recordamos tu examen {{3}} el {{4}}{{5}}. ¡Mucha suerte!",
      "footer": "Gracias por tu confianza"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, et recordem que tens l'examen {{3}} el {{4}}{{5}}.\n\nRecorda portar el DNI i arribar amb temps. Molta sort!",
      "footer": "Gràcies per la teva confiança"
    }
  },
  "examen_recordatorio_lugar_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, te recordamos los datos de tu examen {{3}}.\n\n*Cuándo:* {{4}}\n*Dónde:* {{5}}\n*Qué tienes que llevar:* {{6}}\n\nLlega con tiempo al lugar del examen. Si tienes cualquier duda, escríbenos por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, et recordem les dades del teu examen {{3}}.\n\n*Quan:* {{4}}\n*On:* {{5}}\n*Què has de portar:* {{6}}\n\nArriba amb temps al lloc de l'examen. Si tens qualsevol dubte, escriu-nos per aquest xat."
    }
  },
  "examen_resultado_crm_trial_v2": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, ya tenemos el resultado de tu examen de conducir {{3}}. El resultado ha sido: *{{4}}*. Para cualquier duda, no dudes en contactar con nosotros.",
      "footer": "Gracias por tu confianza"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, ja tenim el resultat del teu examen de conduir {{3}}. El resultat ha estat: *{{4}}*. Per a qualsevol dubte, no dubtis a contactar amb nosaltres.",
      "footer": "Gràcies per la teva confiança"
    }
  },
  "factura_alumno_autoescuela_trial": {
    "es": {
      "documento": true,
      "body": "Le escribe *{{1}}*.\n\nHola {{2}}, aquí tienes tu factura {{3}}. Gracias por confiar en nosotros para sacarte el carnet. 🚗",
      "footer": "Conextcrm · Facturación"
    },
    "ca": {
      "documento": true,
      "body": "T'escriu *{{1}}*.\n\nHola {{2}}, aquí tens la teva factura {{3}}. Gràcies per confiar en nosaltres per treure't el carnet. 🚗",
      "footer": "Conextcrm · Facturació"
    }
  },
  "horario_manana_profesor_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHorario de mañana listo ✅\n\nHola {{2}}, mañana {{3}} tienes {{4}}.\n\nPulsa el botón para ver cada práctica con su hora, alumno y coche, y avisar si no puedes dar alguna clase.",
      "cta": "Ver mi horario"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHorari de demà a punt ✅\n\nHola {{2}}, demà {{3}} tens {{4}}.\n\nPrem el botó per veure cada pràctica amb l'hora, l'alumne i el cotxe, i avisar si no pots fer alguna classe.",
      "cta": "Veure el meu horari"
    }
  },
  "matricula_plazo_cobrado_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\n✅ Pago recibido. Hola {{2}}, hemos cobrado en tu tarjeta el plazo {{3}} de tu matrícula, por importe de {{4}}. Gracias.",
      "footer": "Gracias por tu confianza"
    }
  },
  "matricula_plazo_preaviso_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, el {{3}} se cargará en la tarjeta que guardaste al matricularte el plazo {{4}} de tu matrícula, por importe de {{5}}. Si necesitas cambiar algo, responde a este mensaje.",
      "footer": "Gracias por tu confianza"
    }
  },
  "mensaje_alumno_aviso_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nMensaje recibido de un alumno ✅\n\n{{2}} ha escrito al número de avisos: «{{3}}»\n\nPulsa el botón para abrir su chat en la app y contestarle.",
      "cta": "Abrir chat"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nMissatge rebut d'un alumne ✅\n\n{{2}} ha escrit al número d'avisos: «{{3}}»\n\nPrem el botó per obrir el seu xat a l'aplicació i contestar-li.",
      "cta": "Obrir xat"
    }
  },
  "practica_adelantar_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe ha quedado libre el {{3}} a las {{4}} con {{5}}. Tu práctica está el {{6}} a las {{7}}.\n\nSi te viene bien adelantarla, pulsa Adelantar y pasa a esa hora. Si no, se queda como está.",
      "botones": [
        "Adelantar",
        "Dejarla como está"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nHa quedat lliure el {{3}} a les {{4}} amb {{5}}. La teva pràctica és el {{6}} a les {{7}}.\n\nSi et va bé avançar-la, prem Avançar i passa a aquesta hora. Si no, es queda com està.",
      "botones": [
        "Avançar",
        "Deixar-la com està"
      ]
    }
  },
  "practica_asignada_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\n¡Te esperamos!",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nT'esperem!",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practica_asignada_crm_trial_btn": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\n¡Te esperamos!",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nT'esperem!",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practica_asignada_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\n¡Te esperamos!"
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nT'esperem!"
    }
  },
  "practica_asignada_crm_trial_img_btn": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\n¡Te esperamos!",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nT'esperem!",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practica_asignada_pago_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\nImporte: {{6}}. Puedes dejarla pagada con el botón.",
      "footer": "Gracias por tu confianza",
      "cta": "Pagar práctica"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nImport: {{6}}. Pots deixar-la pagada amb el botó.",
      "footer": "Gràcies per la teva confiança",
      "cta": "Pagar pràctica"
    }
  },
  "practica_asignada_pago_oblig_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\nImporte: {{6}}. Para mantenerla, déjala pagada con el botón antes del {{7}}; si no, la hora quedará libre.",
      "footer": "Gracias por tu confianza",
      "cta": "Pagar práctica"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nT'hem assignat una pràctica de {{5}} el {{3}} a les {{4}}.\n\nImport: {{6}}. Per mantenir-la, deixa-la pagada amb el botó abans del {{7}}; si no, l'hora quedarà lliure.",
      "footer": "Gràcies per la teva confiança",
      "cta": "Pagar pràctica"
    }
  },
  "practica_aviso_confirmar_cancelar_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, tienes práctica el {{3}} a las {{4}}.\n\nPulsa «Confirmar práctica» para confirmarla. Si no puedes venir, pulsa «Cancelar práctica».",
      "botones": [
        "Confirmar práctica",
        "Cancelar práctica"
      ]
    }
  },
  "practica_aviso_confirmar_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, tienes práctica el {{3}} a las {{4}}.\n\nPulsa «Confirmar práctica» para confirmarla. Si no puedes venir, avísanos por este chat.",
      "botones": [
        "Confirmar práctica"
      ]
    }
  },
  "practica_cambio_alumno_profesor_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHorario actualizado ✅\n\nHola {{2}}, {{3}} ha cambiado sus prácticas contigo: {{4}}.\n\nPulsa el botón para ver tu horario con cada práctica, alumno y coche.",
      "cta": "Ver mi horario"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHorari actualitzat ✅\n\nHola {{2}}, {{3}} ha canviat les seves pràctiques amb tu: {{4}}.\n\nPrem el botó per veure el teu horari amb cada pràctica, alumne i cotxe.",
      "cta": "Veure el meu horari"
    }
  },
  "practica_cancel_crm_trial": {
    "es": {
      "header": "PRÁCTICA CANCELADA",
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSu práctica del {{3}} a las {{4}} ha sido cancelada.\n\nMotivo: {{5}}\n\nPara reprogramarla, contacte con nosotros.",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "header": "PRÀCTICA CANCEL·LADA",
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva pràctica del {{3}} a les {{4}} s'ha cancel·lat.\n\nMotiu: {{5}}\n\nPer reprogramar-la, contacta amb nosaltres.",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practica_cancelacion_bono_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu práctica del {{3}} a las {{4}} se ha cancelado con menos de {{5}} horas de antelación.\n\nSegún las condiciones del centro, la clase se descuenta de tu bono y no se añade ningún cargo a tu cuenta. Puedes consultarlo con nosotros por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva pràctica del {{3}} a les {{4}} s'ha cancel·lat amb menys de {{5}} hores d'antelació.\n\nSegons les condicions del centre, la classe es descompta del teu bo i no s'afegeix cap càrrec al teu compte. Pots consultar-ho amb nosaltres per aquest xat."
    }
  },
  "practica_cancelacion_cobrada_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\n✅ Pago recibido. Hola {{2}}, tu práctica del {{3}} a las {{4}} se canceló con menos de {{5}} horas de antelación y, según la autorización que firmaste al matricularte, hemos cobrado {{6}} en tu tarjeta guardada. Si tienes alguna duda, responde a este mensaje."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\n✅ Pagament rebut. Hola {{2}}, la teva pràctica del {{3}} a les {{4}} es va cancel·lar amb menys de {{5}} hores d'antelació i, segons l'autorització que vas signar en matricular-te, hem cobrat {{6}} a la teva targeta desada. Si tens cap dubte, respon aquest missatge."
    }
  },
  "practica_cancelacion_pierde_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu práctica del {{3}} a las {{4}} se ha cancelado con menos de {{5}} horas de antelación.\n\nSegún las condiciones del centro, la clase se pierde y cuenta como realizada. Puedes consultarlo con nosotros por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva pràctica del {{3}} a les {{4}} s'ha cancel·lat amb menys de {{5}} hores d'antelació.\n\nSegons les condicions del centre, la classe es perd i compta com a feta. Pots consultar-ho amb nosaltres per aquest xat."
    }
  },
  "practica_cargo_cancelacion_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu práctica del {{3}} a las {{4}} se ha cancelado con menos de {{5}} horas de antelación.\n\nSegún las condiciones del centro, se ha añadido un cargo de {{6}} a tu cuenta. Puedes consultarlo con nosotros por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva pràctica del {{3}} a les {{4}} s'ha cancel·lat amb menys de {{5}} hores d'antelació.\n\nSegons les condicions del centre, s'ha afegit un càrrec de {{6}} al teu compte. Pots consultar-ho amb nosaltres per aquest xat."
    }
  },
  "practica_confirmar_pendiente_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPendiente de confirmar ⏳\n\nHola {{2}}, confírmanos si vas a realizar la clase práctica del {{3}} a las {{4}}, por favor. Gracias!",
      "botones": [
        "Confirmar práctica"
      ]
    }
  },
  "practica_hueco_libre_trial": {
    "es": {
      "header": "PRÁCTICA DISPONIBLE",
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTenemos una práctica de {{3}} reservada para el {{4}} a las {{5}} con {{6}}.\n\nConfírmanos si la quieres y queda a tu nombre.",
      "botones": [
        "Lo quiero",
        "Ahora no"
      ]
    },
    "ca": {
      "header": "PRÀCTICA DISPONIBLE",
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nTenim una pràctica de {{3}} reservada per al {{4}} a les {{5}} amb {{6}}.\n\nConfirma'ns si la vols i quedarà al teu nom.",
      "botones": [
        "La vull",
        "Ara no"
      ]
    }
  },
  "practica_liberada_pago_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPráctica anulada por falta de pago\n\nHola {{2}}, tu práctica del {{3}} a las {{4}} queda anulada porque no estaba pagada {{5}} antes. No se aplica ningún cargo.\n\nPara reprogramarla, escríbenos por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctica anul·lada per falta de pagament\n\nHola {{2}}, la teva pràctica del {{3}} a les {{4}} queda anul·lada perquè no estava pagada {{5}} abans. No s'aplica cap càrrec.\n\nPer reprogramar-la, escriu-nos per aquest xat."
    }
  },
  "practica_modificada_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu {{3}} prevista para el {{4}} a las {{5}} ha sido modificada.\n\n📅 Nueva fecha: {{6}} a las {{7}}\n\n¿Nos confirmas tu asistencia?",
      "footer": "Gracias por tu comprensión",
      "botones": [
        "Confirmar práctica",
        "Cancelar práctica"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva {{3}} prevista per al {{4}} a les {{5}} s'ha modificat.\n\n📅 Nova data: {{6}} a les {{7}}\n\nEns confirmes que hi vindràs?",
      "footer": "Gràcies per la teva comprensió",
      "botones": [
        "Confirmar pràctica",
        "Cancel·lar pràctica"
      ]
    }
  },
  "practica_modificada_crm_trial_sinbtn": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu {{3}} prevista para el {{4}} a las {{5}} ha sido modificada.\n\n📅 Nueva fecha: {{6}} a las {{7}}\n\nSi no te viene bien, avísanos por este chat.",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva {{3}} prevista per al {{4}} a les {{5}} s'ha modificat.\n\n📅 Nova data: {{6}} a les {{7}}\n\nSi no et va bé, avisa'ns per aquest xat.",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practica_modificada_motivo_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu {{3}} prevista para el {{4}} a las {{5}} ha sido modificada.\n\n📅 Nueva fecha: {{6}} a las {{7}}\n\nMotivo: {{8}}\n\nNos confirmas tu asistencia?",
      "footer": "Gracias por tu comprensión",
      "botones": [
        "Confirmar práctica",
        "Cancelar práctica"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva {{3}} prevista per al {{4}} a les {{5}} s'ha modificat.\n\n📅 Nova data: {{6}} a les {{7}}\n\nMotiu: {{8}}\n\nEns confirmes que hi vindràs?",
      "footer": "Gràcies per la teva comprensió",
      "botones": [
        "Confirmar pràctica",
        "Cancel·lar pràctica"
      ]
    }
  },
  "practica_modificada_motivo_crm_trial_sinbtn": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu {{3}} prevista para el {{4}} a las {{5}} ha sido modificada.\n\n📅 Nueva fecha: {{6}} a las {{7}}\n\nMotivo: {{8}}\n\nSi no te viene bien, avísanos por este chat.",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva {{3}} prevista per al {{4}} a les {{5}} s'ha modificat.\n\n📅 Nova data: {{6}} a les {{7}}\n\nMotiu: {{8}}\n\nSi no et va bé, avisa'ns per aquest xat.",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practica_no_confirmada_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPráctica anulada por falta de confirmación\n\nHola {{2}}, tu práctica del {{3}} a las {{4}} queda anulada porque no estaba confirmada {{5}} antes. No se aplica ningún cargo.\n\nPara reprogramarla, escríbenos por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctica anul·lada per falta de confirmació\n\nHola {{2}}, la teva pràctica del {{3}} a les {{4}} queda anul·lada perquè no estava confirmada {{5}} abans. No s'aplica cap càrrec.\n\nPer reprogramar-la, escriu-nos per aquest xat."
    }
  },
  "practica_no_presentado_cargo_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu práctica del {{3}} a las {{4}} consta como no asistida.\n\nSegún las condiciones del centro, se ha añadido un cargo de {{5}} a tu cuenta. Puedes consultarlo con nosotros por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nLa teva pràctica del {{3}} a les {{4}} consta com a no assistida.\n\nSegons les condicions del centre, s'ha afegit un càrrec de {{5}} al teu compte. Pots consultar-ho amb nosaltres per aquest xat."
    }
  },
  "practica_no_presentado_cobrada_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\n✅ Pago recibido. Hola {{2}}, tu práctica del {{3}} a las {{4}} consta como no asistida y, según la autorización que firmaste al matricularte, hemos cobrado {{5}} en tu tarjeta guardada. Si tienes alguna duda, responde a este mensaje."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\n✅ Pagament rebut. Hola {{2}}, la teva pràctica del {{3}} a les {{4}} consta com a no assistida i, segons l'autorització que vas signar en matricular-te, hem cobrat {{5}} a la teva targeta desada. Si tens cap dubte, respon aquest missatge."
    }
  },
  "practica_peticion_no_atendida_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nNo hemos podido asignarte la clase práctica que pediste.\n\nMotivo: {{3}}\n\nEscríbenos por aquí y buscamos otro hueco."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}},\n\nNo t'hem pogut assignar la classe pràctica que vas demanar.\n\nMotiu: {{3}}\n\nEscriu-nos per aquí i buscarem un altre forat."
    }
  },
  "practica_recordatorio_crm_trial": {
    "es": {
      "header": "RECORDATORIO DE PRÁCTICA",
      "body": "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nLe recordamos que tiene una práctica el {{3}} a las {{4}}.\n\n¿Nos confirma su asistencia?",
      "footer": "Gracias por tu comprensión",
      "botones": [
        "Confirmar práctica",
        "Cancelar práctica"
      ]
    },
    "ca": {
      "header": "RECORDATORI DE PRÀCTICA",
      "body": "📩 *{{1}}* t'envia aquest recordatori:\n\nHola {{2}},\n\nEt recordem que tens una pràctica el {{3}} a les {{4}}.\n\nEns confirmes que hi vindràs?",
      "footer": "Gràcies per la teva comprensió",
      "botones": [
        "Confirmar pràctica",
        "Cancel·lar pràctica"
      ]
    }
  },
  "practica_recordatorio_crm_trial_conf": {
    "es": {
      "header": "RECORDATORIO DE PRÁCTICA",
      "body": "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nLe recordamos que tiene una práctica el {{3}} a las {{4}}.\n\nConfirme su asistencia con el botón. Si no puede venir, avísenos por este chat.",
      "footer": "Gracias por tu comprensión",
      "botones": [
        "Confirmar práctica"
      ]
    },
    "ca": {
      "header": "RECORDATORI DE PRÀCTICA",
      "body": "📩 *{{1}}* t'envia aquest recordatori:\n\nHola {{2}},\n\nEt recordem que tens una pràctica el {{3}} a les {{4}}.\n\nConfirma la teva assistència amb el botó. Si no pots venir, avisa'ns per aquest xat.",
      "footer": "Gràcies per la teva comprensió",
      "botones": [
        "Confirmar pràctica"
      ]
    }
  },
  "practica_recordatorio_crm_trial_sinbtn": {
    "es": {
      "header": "RECORDATORIO DE PRÁCTICA",
      "body": "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nLe recordamos que tiene una práctica el {{3}} a las {{4}}.\n\nSi no puede venir, avísenos por este chat.",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "header": "RECORDATORI DE PRÀCTICA",
      "body": "📩 *{{1}}* t'envia aquest recordatori:\n\nHola {{2}},\n\nEt recordem que tens una pràctica el {{3}} a les {{4}}.\n\nSi no pots venir, avisa'ns per aquest xat.",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practica_recordatorio_crm_trial_v2": {
    "es": {
      "header": "RECORDATORIO DE PRÁCTICA",
      "body": "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nLe recordamos que tiene una práctica el {{3}} a las {{4}}.\n\n¿Nos confirma su asistencia?",
      "footer": "Gracias por tu comprensión",
      "botones": [
        "Confirmar práctica",
        "Cambiar hora",
        "Cancelar práctica"
      ]
    },
    "ca": {
      "header": "RECORDATORI DE PRÀCTICA",
      "body": "📩 *{{1}}* t'envia aquest recordatori:\n\nHola {{2}},\n\nEt recordem que tens una pràctica el {{3}} a les {{4}}.\n\nEns confirmes que hi vindràs?",
      "footer": "Gràcies per la teva comprensió",
      "botones": [
        "Confirmar pràctica",
        "Canviar l'hora",
        "Cancel·lar pràctica"
      ]
    }
  },
  "practicas_semana_1_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, esta es tu práctica de esta semana:\n\n• {{3}}\n\nSi te viene bien, pulsa «Me viene bien». Si ese día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctica programada ✅\n\nHola {{2}}, aquesta és la teva pràctica d'aquesta setmana:\n\n• {{3}}\n\nSi et va bé, prem «Em va bé». Si aquell dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_1_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, esta es tu práctica de esta semana:\n\n• {{3}}\n\nSi te viene bien, pulsa «Me viene bien». Si ese día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctica programada ✅\n\nHola {{2}}, aquesta és la teva pràctica d'aquesta setmana:\n\n• {{3}}\n\nSi et va bé, prem «Em va bé». Si aquell dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_2_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_2_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_3_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_3_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_4_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_4_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_5_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_5_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_6_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_6_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_7_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_7_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus prácticas de esta semana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nPràctiques programades ✅\n\nHola {{2}}, aquestes són les teves pràctiques d'aquesta setmana:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi et van bé, prem «Em va bé». Si algun dia no pots venir, prem «Vull canviar alguna cosa» i l'autoescola ho revisarà amb tu.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus prácticas programadas para esta semana:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat.",
      "footer": "Gracias por tu comprensión"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}} 👋\n\nAquestes són les teves pràctiques programades per a aquesta setmana:\n\n{{3}}\n\nPer a qualsevol canvi o cancel·lació, contacta'ns per aquest xat.",
      "footer": "Gràcies per la teva comprensió"
    }
  },
  "practicas_semana_crm_trial_btn": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus prácticas programadas para esta semana:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}} 👋\n\nAquestes són les teves pràctiques programades per a aquesta setmana:\n\n{{3}}\n\nPer a qualsevol canvi o cancel·lació, contacta'ns per aquest xat.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_semana_crm_trial_img": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus prácticas programadas para esta semana:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat."
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}} 👋\n\nAquestes són les teves pràctiques programades per a aquesta setmana:\n\n{{3}}\n\nPer a qualsevol canvi o cancel·lació, contacta'ns per aquest xat."
    }
  },
  "practicas_semana_crm_trial_img_btn": {
    "es": {
      "imagen": true,
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus prácticas programadas para esta semana:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "imagen": true,
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}} 👋\n\nAquestes són les teves pràctiques programades per a aquesta setmana:\n\n{{3}}\n\nPer a qualsevol canvi o cancel·lació, contacta'ns per aquest xat.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "practicas_sin_confirmar_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPendiente de confirmar ⏳\n\nHola {{2}}, todavía no nos has contestado sobre {{3}}.\n\nPulsa «Me viene bien» para confirmarlo o «Quiero cambiar algo» si no puedes venir.",
      "botones": [
        "Me viene bien",
        "Quiero cambiar algo"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPendent de confirmar ⏳\n\nHola {{2}}, encara no ens has contestat sobre {{3}}.\n\nPrem «Em va bé» per confirmar-ho o «Vull canviar alguna cosa» si no pots venir.",
      "botones": [
        "Em va bé",
        "Vull canviar alguna cosa"
      ]
    }
  },
  "resena_google_autoescuela_trial": {
    "es": {
      "body": "📩 *{{1}}* te escribe:\n\nHola {{2}}, gracias por confiar en nosotros para sacarte el carnet. 🚗\n\n¿Nos dejas una reseña sobre tu experiencia en la autoescuela? {{3}}\n\n¡Gracias por tu confianza! 🙏",
      "cta": "Dejar reseña"
    }
  },
  "saldo_pendiente_alumno_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, el saldo pendiente de tu cuenta es de {{3}} ({{4}}).\n\nPuedes abonarlo en la oficina de la autoescuela. Si tienes cualquier duda, escríbenos por este chat."
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, el saldo pendent del teu compte és de {{3}} ({{4}}).\n\nPots abonar-lo a l'oficina de l'autoescola. Si tens qualsevol dubte, escriu-nos per aquest xat."
    }
  },
  "semana_profesor_crm_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nPlanificación semanal lista ✅\n\nHola {{2}}, tu semana del {{3}} al {{4}} tiene {{5}} en total.\n\nPulsa el botón para ver cada práctica con su hora, alumno y coche, y avisar si algún día no puedes dar clase.",
      "cta": "Ver mi semana"
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nPlanificació setmanal a punt ✅\n\nHola {{2}}, la teva setmana del {{3}} al {{4}} té {{5}} en total.\n\nPrem el botó per veure cada pràctica amb l'hora, l'alumne i el cotxe, i avisar si algun dia no pots fer classe.",
      "cta": "Veure la meva setmana"
    }
  },
  "test_teorica_diario_flow_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, tu test de teórica del {{3}} está listo: {{4}} preguntas del permiso {{5}}.\n\nPara dejar de recibirlo, escribe STOP TEST.",
      "flow": "Hacer el test"
    }
  },
  "test_teorica_diario_trial": {
    "es": {
      "body": "📩 *{{1}}* te informa:\n\nHola {{2}}, tu test de teórica del {{3}} está listo: {{4}} preguntas del permiso {{5}}.\n\nPara dejar de recibirlo, escribe STOP TEST.",
      "botones": [
        "Hacer el test"
      ]
    },
    "ca": {
      "body": "📩 *{{1}}* t'informa:\n\nHola {{2}}, el teu test de teòrica del {{3}} està a punt: {{4}} preguntes del permís {{5}}.\n\nPer deixar de rebre'l, escriu STOP TEST.",
      "botones": [
        "Fer el test"
      ]
    }
  }
};
// ── catálogo generado (fin) ──

/** ¿Está traducida al catalán? (si no, sale en castellano aunque la autoescuela lo tenga en catalán). PURA. */
function tieneCatalan(nombre) {
  const p = PLANTILLAS_AUTOESCUELA[nombre];
  return !!(p && p.ca);
}

/** Los textos de la plantilla estándar en ese idioma (castellano si no está traducida, como c_sendTemplate). PURA. */
function textosPlantilla(nombre, idioma = "es") {
  const p = PLANTILLAS_AUTOESCUELA[nombre];
  if (!p) return null;
  return idioma === "ca" && p.ca ? p.ca : p.es;
}

/** {{n}} → vals[n-1] (lo que falte se queda como {{n}}). PURA. */
function rellenarPlantilla(texto, vals = []) {
  return String(texto || "").replace(/\{\{(\d+)\}\}/g, (m, n) => {
    const v = vals[Number(n) - 1];
    return v === undefined || v === null ? m : String(v);
  });
}

/**
 * Lo que recibe el alumno con la plantilla `nombre` (la _trial que elige el envío para esa empresa):
 *  · en catalán si `idioma` es "ca" y la plantilla está traducida (si no, castellano, como c_sendTemplate);
 *  · la A MEDIDA de la empresa si su mapa (`aMedida`, c_getAutoescuelaConfig → plantillas_a_medida) la sustituye;
 *  · con los valores puestos (`vals[0]` = {{1}}, el nombre del negocio en las _trial).
 * Devuelve { plantilla, base, idioma, aMedida, header?, message, footer?, buttons?, cta?, flow?, conImagen?,
 * conDocumento? } o null si no es una plantilla de autoescuela. PURA.
 */
function vistaPlantilla(nombre, { idioma = "es", vals = [], aMedida = null } = {}) {
  const est = PLANTILLAS_AUTOESCUELA[nombre];
  if (!est) return null;
  const lang = idioma === "ca" && est.ca ? "ca" : "es";
  const base = est[lang];
  const custom = elegirAMedida(aMedida, nombre, lang);
  const am = custom ? definicionAMedida(custom, lang) || {} : {};
  const pick = (k) => (am[k] !== undefined ? am[k] : base[k]);
  const header = pick("header");
  const footer = pick("footer");
  const botones = am.botones || base.botones;
  // El texto del botón URL/Flow de la a medida (`cta`) sustituye al de la base, sea cual sea su tipo.
  const cta = base.cta ? am.cta || base.cta : undefined;
  const flow = base.flow ? am.cta || base.flow : undefined;
  return {
    plantilla: custom || nombre,
    base: nombre,
    idioma: lang,
    aMedida: !!custom,
    ...(header ? { header } : {}),
    message: rellenarPlantilla(pick("body"), vals),
    ...(footer ? { footer } : {}),
    ...(botones && botones.length ? { buttons: [...botones] } : {}),
    ...(cta ? { cta } : {}),
    ...(flow ? { flow } : {}),
    ...(base.imagen ? { conImagen: true } : {}),
    ...(base.documento ? { conDocumento: true } : {}),
  };
}
// ── plantillasAutoescuela: cuerpo compartido (fin) ──

export { PLANTILLAS_AUTOESCUELA, textosPlantilla, rellenarPlantilla, vistaPlantilla, tieneCatalan };
